
/**
 * Copyright (c) 2018 Microsoft Corporation
 * Modules Registration
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

/**
 * Register all available modules
 */
export const registerAllModules = (requiredModules) => {
    let binding = { modules: {}, dataActions: {} };
    const { log, error }  = console;
    const detailedWebpackError = (msg, errorObject) => { error(msg); error(errorObject); process.env.NODE_ENV !== 'development' && error('Run in dev mode to see full list of errors'); process.exit(50); }
    const handleError = (modPath, errObject) => {
        detailedWebpackError('Error with path: ' + modPath, errObject);
    }
    if (requiredModules) {
        requiredModules = requiredModules.map((module) => module.toLowerCase());
    }
    const isNotRegistered = (moduleName) => {
        return !requiredModules || requiredModules.length <= 0 || requiredModules.findIndex((module) => module === moduleName) !== -1;
    };

    
    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    
    try {


    isNotRegistered('absolute-arct-contact') && (binding.modules['absolute-arct-contact'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-arct-contact' */
            'partner/modules/absolute-arct-contact/absolute-arct-contact.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-arct-contact',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-arct-contact'
    });
        

    isNotRegistered('absolute-arct-returns') && (binding.modules['absolute-arct-returns'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-arct-returns' */
            'partner/modules/absolute-arct-returns/absolute-arct-returns.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-arct-returns',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-arct-returns'
    });
        

    isNotRegistered('absolute-arct-warranty') && (binding.modules['absolute-arct-warranty'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-arct-warranty' */
            'partner/modules/absolute-arct-warranty/absolute-arct-warranty.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-arct-warranty',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-arct-warranty'
    });
        

    isNotRegistered('absolute-chart-container') && (binding.modules['absolute-chart-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-chart-container' */
            'partner/modules/absolute-chart-container/absolute-chart-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-chart-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-chart-container'
    });
        

    isNotRegistered('absolute-checkout-delivery-options') && (binding.modules['absolute-checkout-delivery-options'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-checkout-delivery-options' */
            'partner/modules/absolute-checkout-delivery-options/absolute-checkout-delivery-options.tsx'),
        $type: 'contentModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-checkout-delivery-options',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-checkout-delivery-options'
    });
        

    isNotRegistered('absolute-checkout-recaptcha') && (binding.modules['absolute-checkout-recaptcha'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-checkout-recaptcha' */
            'partner/modules/absolute-checkout-recaptcha/absolute-checkout-recaptcha.tsx'),
        $type: 'containerModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/absolute-checkout-recaptcha/actions/get-products-in-active-absolute-checkout-recaptcha-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-checkout-recaptcha',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-checkout-recaptcha'
    });
        

    isNotRegistered('absolute-checkout-terms') && (binding.modules['absolute-checkout-terms'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-checkout-terms' */
            'partner/modules/absolute-checkout-terms/absolute-checkout-terms.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-checkout-terms',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-checkout-terms'
    });
        

    isNotRegistered('absolute-content-block') && (binding.modules['absolute-content-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-content-block' */
            'partner/modules/absolute-content-block/absolute-content-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-content-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-content-block'
    });
        

    isNotRegistered('absolute-content-block-simple') && (binding.modules['absolute-content-block-simple'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-content-block-simple' */
            'partner/modules/absolute-content-block-simple/absolute-content-block-simple.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-content-block-simple',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-content-block-simple'
    });
        

    isNotRegistered('absolute-content-block-sm') && (binding.modules['absolute-content-block-sm'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-content-block-sm' */
            'partner/modules/absolute-content-block-sm/absolute-content-block-sm.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-content-block-sm',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-content-block-sm'
    });
        

    isNotRegistered('absolute-datalayer-begincheckout') && (binding.modules['absolute-datalayer-begincheckout'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-datalayer-begincheckout' */
            'partner/modules/absolute-datalayer-begincheckout/absolute-datalayer-begincheckout.tsx'),
        $type: 'contentModule',
        da: [{name:'products',  path:'modules/absolute-datalayer-begincheckout/actions/get-products-in-active-absolute-layer-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-datalayer-begincheckout',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-datalayer-begincheckout'
    });
        

    isNotRegistered('absolute-ff') && (binding.modules['absolute-ff'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-ff' */
            'partner/modules/absolute-ff/absolute-ff.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-ff',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-ff'
    });
        

    isNotRegistered('absolute-full-charts') && (binding.modules['absolute-full-charts'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-full-charts' */
            'partner/modules/absolute-full-charts/absolute-full-charts.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-full-charts',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-full-charts'
    });
        

    isNotRegistered('absolute-full-contact') && (binding.modules['absolute-full-contact'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-full-contact' */
            'partner/modules/absolute-full-contact/absolute-full-contact.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-full-contact',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-full-contact'
    });
        

    isNotRegistered('absolute-full-returns') && (binding.modules['absolute-full-returns'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-full-returns' */
            'partner/modules/absolute-full-returns/absolute-full-returns.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-full-returns',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-full-returns'
    });
        

    isNotRegistered('absolute-full-warranty') && (binding.modules['absolute-full-warranty'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-full-warranty' */
            'partner/modules/absolute-full-warranty/absolute-full-warranty.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-full-warranty',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-full-warranty'
    });
        

    isNotRegistered('absolute-header') && (binding.modules['absolute-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-header' */
            'partner/modules/absolute-header/absolute-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-header'
    });
        

    isNotRegistered('absolute-layer-checkout') && (binding.modules['absolute-layer-checkout'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-layer-checkout' */
            'partner/modules/absolute-layer-checkout/absolute-layer-checkout.tsx'),
        $type: 'containerModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/absolute-layer-checkout/actions/get-products-in-active-absolute-layer-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-layer-checkout',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-layer-checkout'
    });
        

    isNotRegistered('absolute-media-container') && (binding.modules['absolute-media-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-media-container' */
            'partner/modules/absolute-media-container/absolute-media-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-media-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-media-container'
    });
        

    isNotRegistered('absolute-media-item') && (binding.modules['absolute-media-item'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-media-item' */
            'partner/modules/absolute-media-item/absolute-media-item.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-media-item',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-media-item'
    });
        

    isNotRegistered('absolute-modal-window') && (binding.modules['absolute-modal-window'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-modal-window' */
            'partner/modules/absolute-modal-window/absolute-modal-window.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-modal-window',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-modal-window'
    });
        

    isNotRegistered('absolute-nav-container') && (binding.modules['absolute-nav-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-nav-container' */
            'partner/modules/absolute-nav-container/absolute-nav-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-nav-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-nav-container'
    });
        

    isNotRegistered('absolute-nav-item') && (binding.modules['absolute-nav-item'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-nav-item' */
            'partner/modules/absolute-nav-item/absolute-nav-item.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-nav-item',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-nav-item'
    });
        

    isNotRegistered('absolute-nav22-container') && (binding.modules['absolute-nav22-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-nav22-container' */
            'partner/modules/absolute-nav22-container/absolute-nav22-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-nav22-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-nav22-container'
    });
        

    isNotRegistered('absolute-navigation-menu') && (binding.modules['absolute-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-navigation-menu' */
            'partner/modules/absolute-navigation-menu/absolute-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-navigation-menu'
    });
        

    isNotRegistered('absolute-onyx-contact') && (binding.modules['absolute-onyx-contact'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-onyx-contact' */
            'partner/modules/absolute-onyx-contact/absolute-onyx-contact.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-onyx-contact',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-onyx-contact'
    });
        

    isNotRegistered('absolute-onyx-returns') && (binding.modules['absolute-onyx-returns'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-onyx-returns' */
            'partner/modules/absolute-onyx-returns/absolute-onyx-returns.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-onyx-returns',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-onyx-returns'
    });
        

    isNotRegistered('absolute-onyx-warranty') && (binding.modules['absolute-onyx-warranty'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-onyx-warranty' */
            'partner/modules/absolute-onyx-warranty/absolute-onyx-warranty.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-onyx-warranty',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-onyx-warranty'
    });
        

    isNotRegistered('absolute-promo-banner') && (binding.modules['absolute-promo-banner'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-promo-banner' */
            'partner/modules/absolute-promo-banner/absolute-promo-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-promo-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-promo-banner'
    });
        

    isNotRegistered('absolute-prop65') && (binding.modules['absolute-prop65'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-prop65' */
            'partner/modules/absolute-prop65/absolute-prop65.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-prop65',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-prop65'
    });
        

    isNotRegistered('absolute-salesdata') && (binding.modules['absolute-salesdata'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-salesdata' */
            'partner/modules/absolute-salesdata/absolute-salesdata.tsx'),
        $type: 'scriptModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1},{name:'orderHydration',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-confirmation-with-hydrations', runOn: 0},{name:'tenderTypes',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-salesdata',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-salesdata'
    });
        

    isNotRegistered('absolute-script') && (binding.modules['absolute-script'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-script' */
            'partner/modules/absolute-script/absolute-script.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-script',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-script'
    });
        

    isNotRegistered('absolute-search-result-container') && (binding.modules['absolute-search-result-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-search-result-container' */
            'partner/modules/absolute-search-result-container/absolute-search-result-container.tsx'),
        $type: 'containerModule',
        da: [{name:'category',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category', runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'featureProduct',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'listPageState',  path:'modules/absolute-search-result-container/list-page-state', runOn: 0},{name:'products',  path:'modules/absolute-search-result-container/actions/get-full-products-by-collection', runOn: 0},{name:'refiners',  path:'modules/absolute-search-result-container/actions/get-refiners-for-collection', runOn: 0},{name:'searchConfiguration',  path:'modules/absolute-search-result-container/actions/get-mapped-search-configuration', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-search-result-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-search-result-container'
    });
        

    isNotRegistered('absolute-smooth-scroll') && (binding.modules['absolute-smooth-scroll'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-smooth-scroll' */
            'partner/modules/absolute-smooth-scroll/absolute-smooth-scroll.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-smooth-scroll',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-smooth-scroll'
    });
        

    isNotRegistered('absolute-terms-conditions') && (binding.modules['absolute-terms-conditions'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-terms-conditions' */
            'partner/modules/absolute-terms-conditions/absolute-terms-conditions.tsx'),
        $type: 'contentModule',
        da: [{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-terms-conditions',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-terms-conditions'
    });
        

    isNotRegistered('absolute-video') && (binding.modules['absolute-video'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-video' */
            'partner/modules/absolute-video/absolute-video.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-video',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-video'
    });
        

    isNotRegistered('absolute-video-container') && (binding.modules['absolute-video-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absolute-video-container' */
            'partner/modules/absolute-video-container/absolute-video-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'absolute-video-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/absolute-video-container'
    });
        

    isNotRegistered('absoluteoutdoors') && (binding.modules['absoluteoutdoors'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-absoluteoutdoors' */
            'partner/themes/absoluteoutdoors/absoluteoutdoors.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox','checkout'],
        iNM: false,
        ns: '__local__',
        n: 'absoluteoutdoors',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'absoluteoutdoors.theme.settings.json',
        md: 'src/themes/absoluteoutdoors'
    });
        

    isNotRegistered('aquaglide') && (binding.modules['aquaglide'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-aquaglide' */
            'partner/themes/aquaglide/aquaglide.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'aquaglide',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'aquaglide.theme.settings.json',
        md: 'src/themes/aquaglide'
    });
        

    isNotRegistered('aquaglide-header') && (binding.modules['aquaglide-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-aquaglide-header' */
            'partner/modules/aquaglide-header/aquaglide-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'aquaglide-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/aquaglide-header'
    });
        

    isNotRegistered('aquaglide-navigation-menu') && (binding.modules['aquaglide-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-aquaglide-navigation-menu' */
            'partner/modules/aquaglide-navigation-menu/aquaglide-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'aquaglide-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/aquaglide-navigation-menu'
    });
        

    isNotRegistered('aquaglide-visibility-container') && (binding.modules['aquaglide-visibility-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-aquaglide-visibility-container' */
            'partner/modules/aquaglide-visibility-container/aquaglide-visibility-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'aquaglide-visibility-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/aquaglide-visibility-container'
    });
        

    isNotRegistered('arborb2b-cart') && (binding.modules['arborb2b-cart'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-arborb2b-cart' */
            'partner/modules/arborb2b-cart/arborb2b-cart.tsx'),
        $type: 'containerModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orderTemplates',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview', runOn: 1},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 0},{name:'productAvailabilites',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines', runOn: 0},{name:'products',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 0},{name:'wishlistItems',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'arborb2b-cart',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/arborb2b-cart'
    });
        

    isNotRegistered('arborb2b-contact-form') && (binding.modules['arborb2b-contact-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-arborb2b-contact-form' */
            'partner/modules/arborb2b-contact-form/arborb2b-contact-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'arborb2b-contact-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/arborb2b-contact-form'
    });
        

    isNotRegistered('arborb2b-header') && (binding.modules['arborb2b-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-arborb2b-header' */
            'partner/modules/arborb2b-header/arborb2b-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'arborb2b-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/arborb2b-header'
    });
        

    isNotRegistered('arborb2b-navigation-menu') && (binding.modules['arborb2b-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-arborb2b-navigation-menu' */
            'partner/modules/arborb2b-navigation-menu/arborb2b-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'arborb2b-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/arborb2b-navigation-menu'
    });
        

    isNotRegistered('arborbb') && (binding.modules['arborbb'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-arborbb' */
            'partner/themes/arborbb/arborbb.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'arborbb',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'arborbb.theme.settings.json',
        md: 'src/themes/arborbb'
    });
        

    isNotRegistered('barefootinternational') && (binding.modules['barefootinternational'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-barefootinternational' */
            'partner/themes/kent/kent.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'barefootinternational',
        p: '__local__',
        
        pdp: 'src/themes/kent/kent.definition.json',
        
        themeSettings: 'barefootinternational.theme.settings.json',
        md: 'src/themes/barefootinternational'
    });
        

    isNotRegistered('base-header') && (binding.modules['base-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-base-header' */
            'partner/modules/base-header/base-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'base-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/base-header'
    });
        

    isNotRegistered('base-header-2023') && (binding.modules['base-header-2023'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-base-header-2023' */
            'partner/modules/base-header-2023/base-header-2023.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'base-header-2023',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/base-header-2023'
    });
        

    isNotRegistered('base-navigation-menu') && (binding.modules['base-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-base-navigation-menu' */
            'partner/modules/base-navigation-menu/base-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'base-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/base-navigation-menu'
    });
        

    isNotRegistered('basetheme') && (binding.modules['basetheme'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-basetheme' */
            'partner/themes/basetheme/basetheme.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'basetheme',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'basetheme.theme.settings.json',
        md: 'src/themes/basetheme'
    });
        

    isNotRegistered('connelly-background-video') && (binding.modules['connelly-background-video'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-connelly-background-video' */
            'partner/modules/connelly-background-video/connelly-background-video.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'connelly-background-video',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/connelly-background-video'
    });
        

    isNotRegistered('connelly-invoices-list') && (binding.modules['connelly-invoices-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-connelly-invoices-list' */
            'partner/modules/connelly-invoices-list/connelly-invoices-list.tsx'),
        $type: 'contentModule',
        da: [{name:'b2bUserInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user', runOn: 0},{name:'customer',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'customerBalance',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance', runOn: 0},{name:'invoices',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'connelly-invoices-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/connelly-invoices-list'
    });
        

    isNotRegistered('connellyb2b') && (binding.modules['connellyb2b'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-connellyb2b' */
            'partner/themes/connellyb2b/connellyb2b.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'connellyb2b',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'connellyb2b.theme.settings.json',
        md: 'src/themes/connellyb2b'
    });
        

    isNotRegistered('connellyb2b-header') && (binding.modules['connellyb2b-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-connellyb2b-header' */
            'partner/modules/connellyb2b-header/connellyb2b-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'connellyb2b-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/connellyb2b-header'
    });
        

    isNotRegistered('connellyb2b-header-2023') && (binding.modules['connellyb2b-header-2023'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-connellyb2b-header-2023' */
            'partner/modules/connellyb2b-header-2023/connellyb2b-header-2023.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action', runOn: 1},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1},{name:'wishlists',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'connellyb2b-header-2023',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/connellyb2b-header-2023'
    });
        

    isNotRegistered('connellyb2b-navigation-menu') && (binding.modules['connellyb2b-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-connellyb2b-navigation-menu' */
            'partner/modules/connellyb2b-navigation-menu/connellyb2b-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'connellyb2b-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/connellyb2b-navigation-menu'
    });
        

    isNotRegistered('el-order-history') && (binding.modules['el-order-history'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-el-order-history' */
            'partner/modules/el-order-history/el-order-history.tsx'),
        $type: 'contentModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'channels',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'el-order-history',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/el-order-history'
    });
        

    isNotRegistered('fatsac') && (binding.modules['fatsac'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-fatsac' */
            'partner/themes/kent/kent.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'fatsac',
        p: '__local__',
        
        pdp: 'src/themes/kent/kent.definition.json',
        
        themeSettings: 'fatsac.theme.settings.json',
        md: 'src/themes/fatsac'
    });
        

    isNotRegistered('freedom-header') && (binding.modules['freedom-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-freedom-header' */
            'partner/modules/freedom-header/freedom-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'freedom-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/freedom-header'
    });
        

    isNotRegistered('freedom-nav-container') && (binding.modules['freedom-nav-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-freedom-nav-container' */
            'partner/modules/freedom-nav-container/freedom-nav-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'freedom-nav-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/freedom-nav-container'
    });
        

    isNotRegistered('freedom-nav-item') && (binding.modules['freedom-nav-item'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-freedom-nav-item' */
            'partner/modules/freedom-nav-item/freedom-nav-item.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'freedom-nav-item',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/freedom-nav-item'
    });
        

    isNotRegistered('freedom-navigation-menu') && (binding.modules['freedom-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-freedom-navigation-menu' */
            'partner/modules/freedom-navigation-menu/freedom-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'freedom-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/freedom-navigation-menu'
    });
        

    isNotRegistered('freedom23') && (binding.modules['freedom23'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-freedom23' */
            'partner/themes/freedom23/freedom23.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['content-block'],
        iNM: false,
        ns: '__local__',
        n: 'freedom23',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'freedom23.theme.settings.json',
        md: 'src/themes/freedom23'
    });
        

    isNotRegistered('hosports') && (binding.modules['hosports'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports' */
            'partner/themes/kent/kent.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports',
        p: '__local__',
        
        pdp: 'src/themes/kent/kent.definition.json',
        
        themeSettings: 'hosports.theme.settings.json',
        md: 'src/themes/hosports'
    });
        

    isNotRegistered('hosports-1-column-banner') && (binding.modules['hosports-1-column-banner'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-1-column-banner' */
            'partner/modules/hosports-1-column-banner/hosports-1-column-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-1-column-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-1-column-banner'
    });
        

    isNotRegistered('hosports-2-column-banners') && (binding.modules['hosports-2-column-banners'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-2-column-banners' */
            'partner/modules/hosports-2-column-banners/hosports-2-column-banners.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-2-column-banners',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-2-column-banners'
    });
        

    isNotRegistered('hosports-2-column-images') && (binding.modules['hosports-2-column-images'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-2-column-images' */
            'partner/modules/hosports-2-column-images/hosports-2-column-images.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-2-column-images',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-2-column-images'
    });
        

    isNotRegistered('hosports-2-column-tagged-images') && (binding.modules['hosports-2-column-tagged-images'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-2-column-tagged-images' */
            'partner/modules/hosports-2-column-tagged-images/hosports-2-column-tagged-images.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-2-column-tagged-images',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-2-column-tagged-images'
    });
        

    isNotRegistered('hosports-3-column-banners') && (binding.modules['hosports-3-column-banners'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-3-column-banners' */
            'partner/modules/hosports-3-column-banners/hosports-3-column-banners.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-3-column-banners',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-3-column-banners'
    });
        

    isNotRegistered('hosports-3-column-images') && (binding.modules['hosports-3-column-images'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-3-column-images' */
            'partner/modules/hosports-3-column-images/hosports-3-column-images.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-3-column-images',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-3-column-images'
    });
        

    isNotRegistered('hosports-3-column-tagged-images') && (binding.modules['hosports-3-column-tagged-images'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-3-column-tagged-images' */
            'partner/modules/hosports-3-column-tagged-images/hosports-3-column-tagged-images.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-3-column-tagged-images',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-3-column-tagged-images'
    });
        

    isNotRegistered('hosports-4-column-banners') && (binding.modules['hosports-4-column-banners'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-4-column-banners' */
            'partner/modules/hosports-4-column-banners/hosports-4-column-banners.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-4-column-banners',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-4-column-banners'
    });
        

    isNotRegistered('hosports-4-column-images') && (binding.modules['hosports-4-column-images'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-4-column-images' */
            'partner/modules/hosports-4-column-images/hosports-4-column-images.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-4-column-images',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-4-column-images'
    });
        

    isNotRegistered('hosports-4-column-tagged-images') && (binding.modules['hosports-4-column-tagged-images'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-4-column-tagged-images' */
            'partner/modules/hosports-4-column-tagged-images/hosports-4-column-tagged-images.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-4-column-tagged-images',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-4-column-tagged-images'
    });
        

    isNotRegistered('hosports-accessibility-widget') && (binding.modules['hosports-accessibility-widget'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-accessibility-widget' */
            'partner/modules/hosports-accessibility-widget/hosports-accessibility-widget.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-accessibility-widget',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-accessibility-widget'
    });
        

    isNotRegistered('hosports-anchor-navigation') && (binding.modules['hosports-anchor-navigation'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-anchor-navigation' */
            'partner/modules/hosports-anchor-navigation/hosports-anchor-navigation.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-anchor-navigation',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-anchor-navigation'
    });
        

    isNotRegistered('hosports-b2b') && (binding.modules['hosports-b2b'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-b2b' */
            'partner/themes/kent/kent.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['checkout'],
        iNM: false,
        ns: '__local__',
        n: 'hosports-b2b',
        p: '__local__',
        
        pdp: 'src/themes/kent/kent.definition.json',
        
        themeSettings: 'hosports-b2b.theme.settings.json',
        md: 'src/themes/hosports-b2b'
    });
        

    isNotRegistered('hosports-b2b-additional-product-details') && (binding.modules['hosports-b2b-additional-product-details'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-b2b-additional-product-details' */
            'partner/modules/hosports-b2b-additional-product-details/hosports-b2b-additional-product-details.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-b2b-additional-product-details',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-b2b-additional-product-details'
    });
        

    isNotRegistered('hosports-b2b-header') && (binding.modules['hosports-b2b-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-b2b-header' */
            'partner/modules/hosports-b2b-header/hosports-b2b-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-b2b-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-b2b-header'
    });
        

    isNotRegistered('hosports-b2b-navigation-menu') && (binding.modules['hosports-b2b-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-b2b-navigation-menu' */
            'partner/modules/hosports-b2b-navigation-menu/hosports-b2b-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-b2b-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-b2b-navigation-menu'
    });
        

    isNotRegistered('hosports-basemodule-tester') && (binding.modules['hosports-basemodule-tester'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-basemodule-tester' */
            'partner/modules/hosports-basemodule-tester/hosports-basemodule-tester.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-basemodule-tester',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-basemodule-tester'
    });
        

    isNotRegistered('hosports-board-finder') && (binding.modules['hosports-board-finder'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-board-finder' */
            'partner/modules/hosports-board-finder/hosports-board-finder.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-board-finder',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-board-finder'
    });
        

    isNotRegistered('hosports-button-row') && (binding.modules['hosports-button-row'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-button-row' */
            'partner/modules/hosports-button-row/hosports-button-row.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-button-row',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-button-row'
    });
        

    isNotRegistered('hosports-card-list') && (binding.modules['hosports-card-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-card-list' */
            'partner/modules/hosports-card-list/hosports-card-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-card-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-card-list'
    });
        

    isNotRegistered('hosports-career-detail') && (binding.modules['hosports-career-detail'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-career-detail' */
            'partner/modules/hosports-career-detail/hosports-career-detail.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-career-detail',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-career-detail'
    });
        

    isNotRegistered('hosports-careers-list') && (binding.modules['hosports-careers-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-careers-list' */
            'partner/modules/hosports-careers-list/hosports-careers-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-careers-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-careers-list'
    });
        

    isNotRegistered('hosports-centered-image') && (binding.modules['hosports-centered-image'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-centered-image' */
            'partner/modules/hosports-centered-image/hosports-centered-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-centered-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-centered-image'
    });
        

    isNotRegistered('hosports-centered-quote') && (binding.modules['hosports-centered-quote'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-centered-quote' */
            'partner/modules/hosports-centered-quote/hosports-centered-quote.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-centered-quote',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-centered-quote'
    });
        

    isNotRegistered('hosports-centered-tagged-image') && (binding.modules['hosports-centered-tagged-image'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-centered-tagged-image' */
            'partner/modules/hosports-centered-tagged-image/hosports-centered-tagged-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-centered-tagged-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-centered-tagged-image'
    });
        

    isNotRegistered('hosports-centered-tagged-image-with-color') && (binding.modules['hosports-centered-tagged-image-with-color'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-centered-tagged-image-with-color' */
            'partner/modules/hosports-centered-tagged-image-with-color/hosports-centered-tagged-image-with-color.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-centered-tagged-image-with-color',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-centered-tagged-image-with-color'
    });
        

    isNotRegistered('hosports-collection-browser') && (binding.modules['hosports-collection-browser'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-collection-browser' */
            'partner/modules/hosports-collection-browser/hosports-collection-browser.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-collection-browser',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-collection-browser'
    });
        

    isNotRegistered('hosports-collection-preview') && (binding.modules['hosports-collection-preview'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-collection-preview' */
            'partner/modules/hosports-collection-preview/hosports-collection-preview.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-collection-preview',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-collection-preview'
    });
        

    isNotRegistered('hosports-collection-slider') && (binding.modules['hosports-collection-slider'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-collection-slider' */
            'partner/modules/hosports-collection-slider/hosports-collection-slider.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-collection-slider',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-collection-slider'
    });
        

    isNotRegistered('hosports-constant-contact-form') && (binding.modules['hosports-constant-contact-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-constant-contact-form' */
            'partner/modules/hosports-constant-contact-form/hosports-constant-contact-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-constant-contact-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-constant-contact-form'
    });
        

    isNotRegistered('hosports-contact-form') && (binding.modules['hosports-contact-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-contact-form' */
            'partner/modules/hosports-contact-form/hosports-contact-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-contact-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-contact-form'
    });
        

    isNotRegistered('hosports-costco-registration') && (binding.modules['hosports-costco-registration'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-costco-registration' */
            'partner/modules/hosports-costco-registration/hosports-costco-registration.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-costco-registration',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-costco-registration'
    });
        

    isNotRegistered('hosports-country-select') && (binding.modules['hosports-country-select'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-country-select' */
            'partner/modules/hosports-country-select/hosports-country-select.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-country-select',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-country-select'
    });
        

    isNotRegistered('hosports-custom-product') && (binding.modules['hosports-custom-product'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-custom-product' */
            'partner/modules/hosports-custom-product/hosports-custom-product.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-custom-product',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-custom-product'
    });
        

    isNotRegistered('hosports-custom-sac-artwork-designer') && (binding.modules['hosports-custom-sac-artwork-designer'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-custom-sac-artwork-designer' */
            'partner/modules/hosports-custom-sac-artwork-designer/hosports-custom-sac-artwork-designer.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-custom-sac-artwork-designer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-custom-sac-artwork-designer'
    });
        

    isNotRegistered('hosports-custom-sac-calculator') && (binding.modules['hosports-custom-sac-calculator'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-custom-sac-calculator' */
            'partner/modules/hosports-custom-sac-calculator/hosports-custom-sac-calculator.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-custom-sac-calculator',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-custom-sac-calculator'
    });
        

    isNotRegistered('hosports-custom-sac-page') && (binding.modules['hosports-custom-sac-page'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-custom-sac-page' */
            'partner/modules/hosports-custom-sac-page/hosports-custom-sac-page.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-custom-sac-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-custom-sac-page'
    });
        

    isNotRegistered('hosports-custom-sac-send') && (binding.modules['hosports-custom-sac-send'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-custom-sac-send' */
            'partner/modules/hosports-custom-sac-send/hosports-custom-sac-send.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-custom-sac-send',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-custom-sac-send'
    });
        

    isNotRegistered('hosports-dealer-locator') && (binding.modules['hosports-dealer-locator'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-dealer-locator' */
            'partner/modules/hosports-dealer-locator/hosports-dealer-locator.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-dealer-locator',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-dealer-locator'
    });
        

    isNotRegistered('hosports-dealer-map') && (binding.modules['hosports-dealer-map'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-dealer-map' */
            'partner/modules/hosports-dealer-map/hosports-dealer-map.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-dealer-map',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-dealer-map'
    });
        

    isNotRegistered('hosports-demo-product-form') && (binding.modules['hosports-demo-product-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-demo-product-form' */
            'partner/modules/hosports-demo-product-form/hosports-demo-product-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-demo-product-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-demo-product-form'
    });
        

    isNotRegistered('hosports-demo-product-list') && (binding.modules['hosports-demo-product-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-demo-product-list' */
            'partner/modules/hosports-demo-product-list/hosports-demo-product-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-demo-product-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-demo-product-list'
    });
        

    isNotRegistered('hosports-filterable-category-list') && (binding.modules['hosports-filterable-category-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-filterable-category-list' */
            'partner/modules/hosports-filterable-category-list/hosports-filterable-category-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-filterable-category-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-filterable-category-list'
    });
        

    isNotRegistered('hosports-footer') && (binding.modules['hosports-footer'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-footer' */
            'partner/modules/hosports-footer/hosports-footer.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-footer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-footer'
    });
        

    isNotRegistered('hosports-full-width-image') && (binding.modules['hosports-full-width-image'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-full-width-image' */
            'partner/modules/hosports-full-width-image/hosports-full-width-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-full-width-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-full-width-image'
    });
        

    isNotRegistered('hosports-full-width-tagged-image') && (binding.modules['hosports-full-width-tagged-image'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-full-width-tagged-image' */
            'partner/modules/hosports-full-width-tagged-image/hosports-full-width-tagged-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-full-width-tagged-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-full-width-tagged-image'
    });
        

    isNotRegistered('hosports-header') && (binding.modules['hosports-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-header' */
            'partner/modules/hosports-header/hosports-header.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-header'
    });
        

    isNotRegistered('hosports-hero') && (binding.modules['hosports-hero'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-hero' */
            'partner/modules/hosports-hero/hosports-hero.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-hero',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-hero'
    });
        

    isNotRegistered('hosports-history-list') && (binding.modules['hosports-history-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-history-list' */
            'partner/modules/hosports-history-list/hosports-history-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-history-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-history-list'
    });
        

    isNotRegistered('hosports-holiday-theme') && (binding.modules['hosports-holiday-theme'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-holiday-theme' */
            'partner/modules/hosports-holiday-theme/hosports-holiday-theme.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-holiday-theme',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-holiday-theme'
    });
        

    isNotRegistered('hosports-hover-thumb') && (binding.modules['hosports-hover-thumb'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-hover-thumb' */
            'partner/modules/hosports-hover-thumb/hosports-hover-thumb.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-hover-thumb',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-hover-thumb'
    });
        

    isNotRegistered('hosports-icon-link-row') && (binding.modules['hosports-icon-link-row'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-icon-link-row' */
            'partner/modules/hosports-icon-link-row/hosports-icon-link-row.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-icon-link-row',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-icon-link-row'
    });
        

    isNotRegistered('hosports-image-row') && (binding.modules['hosports-image-row'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-image-row' */
            'partner/modules/hosports-image-row/hosports-image-row.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-image-row',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-image-row'
    });
        

    isNotRegistered('hosports-modal') && (binding.modules['hosports-modal'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-modal' */
            'partner/modules/hosports-modal/hosports-modal.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-modal',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-modal'
    });
        

    isNotRegistered('hosports-package-builder') && (binding.modules['hosports-package-builder'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-package-builder' */
            'partner/modules/hosports-package-builder/hosports-package-builder.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-package-builder',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-package-builder'
    });
        

    isNotRegistered('hosports-parallax-full-width-image') && (binding.modules['hosports-parallax-full-width-image'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-parallax-full-width-image' */
            'partner/modules/hosports-parallax-full-width-image/hosports-parallax-full-width-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-parallax-full-width-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-parallax-full-width-image'
    });
        

    isNotRegistered('hosports-parallax-full-width-image-and-color') && (binding.modules['hosports-parallax-full-width-image-and-color'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-parallax-full-width-image-and-color' */
            'partner/modules/hosports-parallax-full-width-image-and-color/hosports-parallax-full-width-image-and-color.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-parallax-full-width-image-and-color',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-parallax-full-width-image-and-color'
    });
        

    isNotRegistered('hosports-parallax-two-image-overlapping-loose-grid') && (binding.modules['hosports-parallax-two-image-overlapping-loose-grid'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-parallax-two-image-overlapping-loose-grid' */
            'partner/modules/hosports-parallax-two-image-overlapping-loose-grid/hosports-parallax-two-image-overlapping-loose-grid.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-parallax-two-image-overlapping-loose-grid',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-parallax-two-image-overlapping-loose-grid'
    });
        

    isNotRegistered('hosports-partners-list') && (binding.modules['hosports-partners-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-partners-list' */
            'partner/modules/hosports-partners-list/hosports-partners-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-partners-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-partners-list'
    });
        

    isNotRegistered('hosports-product-category') && (binding.modules['hosports-product-category'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-product-category' */
            'partner/modules/hosports-product-category/hosports-product-category.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-product-category',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-product-category'
    });
        

    isNotRegistered('hosports-product-detail') && (binding.modules['hosports-product-detail'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-product-detail' */
            'partner/modules/hosports-product-detail/hosports-product-detail.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-product-detail',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-product-detail'
    });
        

    isNotRegistered('hosports-product-list') && (binding.modules['hosports-product-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-product-list' */
            'partner/modules/hosports-product-list/hosports-product-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-product-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-product-list'
    });
        

    isNotRegistered('hosports-retailer-login') && (binding.modules['hosports-retailer-login'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-retailer-login' */
            'partner/modules/hosports-retailer-login/hosports-retailer-login.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-retailer-login',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-retailer-login'
    });
        

    isNotRegistered('hosports-sac-finder') && (binding.modules['hosports-sac-finder'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-sac-finder' */
            'partner/modules/hosports-sac-finder/hosports-sac-finder.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-sac-finder',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-sac-finder'
    });
        

    isNotRegistered('hosports-side-by-side-text-and-image') && (binding.modules['hosports-side-by-side-text-and-image'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-side-by-side-text-and-image' */
            'partner/modules/hosports-side-by-side-text-and-image/hosports-side-by-side-text-and-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-side-by-side-text-and-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-side-by-side-text-and-image'
    });
        

    isNotRegistered('hosports-site-config') && (binding.modules['hosports-site-config'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-site-config' */
            'partner/modules/hosports-site-config/hosports-site-config.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-site-config',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-site-config'
    });
        

    isNotRegistered('hosports-slider') && (binding.modules['hosports-slider'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-slider' */
            'partner/modules/hosports-slider/hosports-slider.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-slider',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-slider'
    });
        

    isNotRegistered('hosports-small-centered-paragraph') && (binding.modules['hosports-small-centered-paragraph'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-small-centered-paragraph' */
            'partner/modules/hosports-small-centered-paragraph/hosports-small-centered-paragraph.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-small-centered-paragraph',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-small-centered-paragraph'
    });
        

    isNotRegistered('hosports-staggered-products-list') && (binding.modules['hosports-staggered-products-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-staggered-products-list' */
            'partner/modules/hosports-staggered-products-list/hosports-staggered-products-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-staggered-products-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-staggered-products-list'
    });
        

    isNotRegistered('hosports-staggered-subcategory-list') && (binding.modules['hosports-staggered-subcategory-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-staggered-subcategory-list' */
            'partner/modules/hosports-staggered-subcategory-list/hosports-staggered-subcategory-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-staggered-subcategory-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-staggered-subcategory-list'
    });
        

    isNotRegistered('hosports-support-page') && (binding.modules['hosports-support-page'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-support-page' */
            'partner/modules/hosports-support-page/hosports-support-page.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-support-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-support-page'
    });
        

    isNotRegistered('hosports-tagged-image') && (binding.modules['hosports-tagged-image'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-tagged-image' */
            'partner/modules/hosports-tagged-image/hosports-tagged-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-tagged-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-tagged-image'
    });
        

    isNotRegistered('hosports-team-detail') && (binding.modules['hosports-team-detail'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-team-detail' */
            'partner/modules/hosports-team-detail/hosports-team-detail.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-team-detail',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-team-detail'
    });
        

    isNotRegistered('hosports-team-list') && (binding.modules['hosports-team-list'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-team-list' */
            'partner/modules/hosports-team-list/hosports-team-list.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-team-list',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-team-list'
    });
        

    isNotRegistered('hosports-tv-page') && (binding.modules['hosports-tv-page'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-tv-page' */
            'partner/modules/hosports-tv-page/hosports-tv-page.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-tv-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-tv-page'
    });
        

    isNotRegistered('hosports-tv-teasers') && (binding.modules['hosports-tv-teasers'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-tv-teasers' */
            'partner/modules/hosports-tv-teasers/hosports-tv-teasers.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-tv-teasers',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-tv-teasers'
    });
        

    isNotRegistered('hosports-video-box') && (binding.modules['hosports-video-box'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-video-box' */
            'partner/modules/hosports-video-box/hosports-video-box.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-video-box',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-video-box'
    });
        

    isNotRegistered('hosports-video-hero') && (binding.modules['hosports-video-hero'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-video-hero' */
            'partner/modules/hosports-video-hero/hosports-video-hero.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-video-hero',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-video-hero'
    });
        

    isNotRegistered('hosports-video-intro') && (binding.modules['hosports-video-intro'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-video-intro' */
            'partner/modules/hosports-video-intro/hosports-video-intro.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-video-intro',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-video-intro'
    });
        

    isNotRegistered('hosports-video-page') && (binding.modules['hosports-video-page'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-video-page' */
            'partner/modules/hosports-video-page/hosports-video-page.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-video-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-video-page'
    });
        

    isNotRegistered('hosports-zendesk') && (binding.modules['hosports-zendesk'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hosports-zendesk' */
            'partner/modules/hosports-zendesk/hosports-zendesk.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hosports-zendesk',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hosports-zendesk'
    });
        

    isNotRegistered('hyperlite') && (binding.modules['hyperlite'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-hyperlite' */
            'partner/themes/kent/kent.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hyperlite',
        p: '__local__',
        
        pdp: 'src/themes/kent/kent.definition.json',
        
        themeSettings: 'hyperlite.theme.settings.json',
        md: 'src/themes/hyperlite'
    });
        

    isNotRegistered('kent') && (binding.modules['kent'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-kent' */
            'partner/themes/kent/kent.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'kent',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'kent.theme.settings.json',
        md: 'src/themes/kent'
    });
        

    isNotRegistered('kent-header') && (binding.modules['kent-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-kent-header' */
            'partner/modules/kent-header/kent-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'kent-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/kent-header'
    });
        

    isNotRegistered('kent-navigation-menu') && (binding.modules['kent-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-kent-navigation-menu' */
            'partner/modules/kent-navigation-menu/kent-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'kent-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/kent-navigation-menu'
    });
        

    isNotRegistered('liquid-category-image') && (binding.modules['liquid-category-image'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-liquid-category-image' */
            'partner/modules/liquid-category-image/liquid-category-image.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'liquid-category-image',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/liquid-category-image'
    });
        

    isNotRegistered('liquid-container') && (binding.modules['liquid-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-liquid-container' */
            'partner/modules/liquid-container/liquid-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'liquid-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/liquid-container'
    });
        

    isNotRegistered('liquid-header-2021') && (binding.modules['liquid-header-2021'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-liquid-header-2021' */
            'partner/modules/liquid-header-2021/liquid-header-2021.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'liquid-header-2021',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/liquid-header-2021'
    });
        

    isNotRegistered('liquid-locator') && (binding.modules['liquid-locator'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-liquid-locator' */
            'partner/modules/liquid-locator/liquid-locator.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'liquid-locator',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/liquid-locator'
    });
        

    isNotRegistered('liquid-locator23') && (binding.modules['liquid-locator23'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-liquid-locator23' */
            'partner/modules/liquid-locator23/liquid-locator23.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'liquid-locator23',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/liquid-locator23'
    });
        

    isNotRegistered('liquid-navigation-menu') && (binding.modules['liquid-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-liquid-navigation-menu' */
            'partner/modules/liquid-navigation-menu/liquid-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'liquid-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/liquid-navigation-menu'
    });
        

    isNotRegistered('liquid-navigation-menu-2022') && (binding.modules['liquid-navigation-menu-2022'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-liquid-navigation-menu-2022' */
            'partner/modules/liquid-navigation-menu-2022/liquid-navigation-menu-2022.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'liquid-navigation-menu-2022',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/liquid-navigation-menu-2022'
    });
        

    isNotRegistered('liquid-script') && (binding.modules['liquid-script'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-liquid-script' */
            'partner/modules/liquid-script/liquid-script.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'liquid-script',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/liquid-script'
    });
        

    isNotRegistered('liquid-upc') && (binding.modules['liquid-upc'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-liquid-upc' */
            'partner/modules/liquid-upc/liquid-upc.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'liquid-upc',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/liquid-upc'
    });
        

    isNotRegistered('liquid23') && (binding.modules['liquid23'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-liquid23' */
            'partner/themes/liquid23/liquid23.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['checkout-section-container','checkout'],
        iNM: false,
        ns: '__local__',
        n: 'liquid23',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'liquid23.theme.settings.json',
        md: 'src/themes/liquid23'
    });
        

    isNotRegistered('liquid23-search-result-container') && (binding.modules['liquid23-search-result-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-liquid23-search-result-container' */
            'partner/modules/liquid23-search-result-container/liquid23-search-result-container.tsx'),
        $type: 'containerModule',
        da: [{name:'category',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category', runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'featureProduct',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'listPageState',  path:'modules/liquid23-search-result-container/list-page-state', runOn: 0},{name:'products',  path:'modules/liquid23-search-result-container/actions/get-full-products-by-collection', runOn: 0},{name:'refiners',  path:'modules/liquid23-search-result-container/actions/get-refiners-for-collection', runOn: 0},{name:'searchConfiguration',  path:'modules/liquid23-search-result-container/actions/get-mapped-search-configuration', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'liquid23-search-result-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/liquid23-search-result-container'
    });
        

    isNotRegistered('lli-checkout') && (binding.modules['lli-checkout'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lli-checkout' */
            'partner/modules/lli-checkout/lli-checkout.tsx'),
        $type: 'containerModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/lli-checkout/actions/get-products-in-active-lli-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lli-checkout',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lli-checkout'
    });
        

    isNotRegistered('lli-checkout-additional-info') && (binding.modules['lli-checkout-additional-info'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lli-checkout-additional-info' */
            'partner/modules/lli-checkout-additional-info/lli-checkout-additional-info.tsx'),
        $type: 'contentModule',
        da: [{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 1},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'lli-checkout-additional-info',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lli-checkout-additional-info'
    });
        

    isNotRegistered('lli-order-history') && (binding.modules['lli-order-history'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-lli-order-history' */
            'partner/modules/lli-order-history/lli-order-history.tsx'),
        $type: 'contentModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'channels',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels', runOn: 0},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'lli-order-history',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lli-order-history'
    });
        

    isNotRegistered('obrien-about23') && (binding.modules['obrien-about23'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-about23' */
            'partner/modules/obrien-about23/obrien-about23.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-about23',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-about23'
    });
        

    isNotRegistered('obrien-above-footer') && (binding.modules['obrien-above-footer'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-above-footer' */
            'partner/modules/obrien-above-footer/obrien-above-footer.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-above-footer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-above-footer'
    });
        

    isNotRegistered('obrien-background-video') && (binding.modules['obrien-background-video'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-background-video' */
            'partner/modules/obrien-background-video/obrien-background-video.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-background-video',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-background-video'
    });
        

    isNotRegistered('obrien-checkout') && (binding.modules['obrien-checkout'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-checkout' */
            'partner/modules/obrien-checkout/obrien-checkout.tsx'),
        $type: 'containerModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/obrien-checkout/actions/get-products-in-active-obrien-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-checkout',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-checkout'
    });
        

    isNotRegistered('obrien-checkout-payment-instrument') && (binding.modules['obrien-checkout-payment-instrument'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-checkout-payment-instrument' */
            'partner/modules/obrien-checkout-payment-instrument/obrien-checkout-payment-instrument.tsx'),
        $type: 'contentModule',
        da: [{name:'cardPaymentAcceptPoint',  path:'modules/obrien-checkout-payment-instrument/actions/get-card-payment-accept-point', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-checkout-payment-instrument',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-checkout-payment-instrument'
    });
        

    isNotRegistered('obrien-contact-2021') && (binding.modules['obrien-contact-2021'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-contact-2021' */
            'partner/modules/obrien-contact-2021/obrien-contact-2021.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-contact-2021',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-contact-2021'
    });
        

    isNotRegistered('obrien-contact-form') && (binding.modules['obrien-contact-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-contact-form' */
            'partner/modules/obrien-contact-form/obrien-contact-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-contact-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-contact-form'
    });
        

    isNotRegistered('obrien-content-block') && (binding.modules['obrien-content-block'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-content-block' */
            'partner/modules/obrien-content-block/obrien-content-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-content-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-content-block'
    });
        

    isNotRegistered('obrien-content-block-simple') && (binding.modules['obrien-content-block-simple'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-content-block-simple' */
            'partner/modules/obrien-content-block-simple/obrien-content-block-simple.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-content-block-simple',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-content-block-simple'
    });
        

    isNotRegistered('obrien-content-block-team') && (binding.modules['obrien-content-block-team'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-content-block-team' */
            'partner/modules/obrien-content-block-team/obrien-content-block-team.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-content-block-team',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-content-block-team'
    });
        

    isNotRegistered('obrien-default-page') && (binding.modules['obrien-default-page'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-default-page' */
            'partner/modules/obrien-default-page/obrien-default-page.tsx'),
        $type: 'pageModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-default-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-default-page'
    });
        

    isNotRegistered('obrien-faq') && (binding.modules['obrien-faq'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-faq' */
            'partner/modules/obrien-faq/obrien-faq.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-faq',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-faq'
    });
        

    isNotRegistered('obrien-ff') && (binding.modules['obrien-ff'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-ff' */
            'partner/modules/obrien-ff/obrien-ff.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-ff',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-ff'
    });
        

    isNotRegistered('obrien-header-2021') && (binding.modules['obrien-header-2021'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-header-2021' */
            'partner/modules/obrien-header-2021/obrien-header-2021.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-header-2021',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-header-2021'
    });
        

    isNotRegistered('obrien-header-2023') && (binding.modules['obrien-header-2023'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-header-2023' */
            'partner/modules/obrien-header-2023/obrien-header-2023.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-header-2023',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-header-2023'
    });
        

    isNotRegistered('obrien-home') && (binding.modules['obrien-home'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-home' */
            'partner/modules/obrien-home/obrien-home.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-home',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-home'
    });
        

    isNotRegistered('obrien-home-about') && (binding.modules['obrien-home-about'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-home-about' */
            'partner/modules/obrien-home-about/obrien-home-about.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-home-about',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-home-about'
    });
        

    isNotRegistered('obrien-home-hero') && (binding.modules['obrien-home-hero'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-home-hero' */
            'partner/modules/obrien-home-hero/obrien-home-hero.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-home-hero',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-home-hero'
    });
        

    isNotRegistered('obrien-home-hero23') && (binding.modules['obrien-home-hero23'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-home-hero23' */
            'partner/modules/obrien-home-hero23/obrien-home-hero23.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-home-hero23',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-home-hero23'
    });
        

    isNotRegistered('obrien-home-slider') && (binding.modules['obrien-home-slider'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-home-slider' */
            'partner/modules/obrien-home-slider/obrien-home-slider.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-home-slider',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-home-slider'
    });
        

    isNotRegistered('obrien-id-container') && (binding.modules['obrien-id-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-id-container' */
            'partner/modules/obrien-id-container/obrien-id-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-id-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-id-container'
    });
        

    isNotRegistered('obrien-locator') && (binding.modules['obrien-locator'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-locator' */
            'partner/modules/obrien-locator/obrien-locator.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-locator',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-locator'
    });
        

    isNotRegistered('obrien-locator22') && (binding.modules['obrien-locator22'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-locator22' */
            'partner/modules/obrien-locator22/obrien-locator22.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-locator22',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-locator22'
    });
        

    isNotRegistered('obrien-main-fader') && (binding.modules['obrien-main-fader'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-main-fader' */
            'partner/modules/obrien-main-fader/obrien-main-fader.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-main-fader',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-main-fader'
    });
        

    isNotRegistered('obrien-modal-window') && (binding.modules['obrien-modal-window'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-modal-window' */
            'partner/modules/obrien-modal-window/obrien-modal-window.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-modal-window',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-modal-window'
    });
        

    isNotRegistered('obrien-nav-container') && (binding.modules['obrien-nav-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-nav-container' */
            'partner/modules/obrien-nav-container/obrien-nav-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-nav-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-nav-container'
    });
        

    isNotRegistered('obrien-nav-item') && (binding.modules['obrien-nav-item'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-nav-item' */
            'partner/modules/obrien-nav-item/obrien-nav-item.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-nav-item',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-nav-item'
    });
        

    isNotRegistered('obrien-navigation-menu') && (binding.modules['obrien-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-navigation-menu' */
            'partner/modules/obrien-navigation-menu/obrien-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-navigation-menu'
    });
        

    isNotRegistered('obrien-performance-charts') && (binding.modules['obrien-performance-charts'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-performance-charts' */
            'partner/modules/obrien-performance-charts/obrien-performance-charts.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-performance-charts',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-performance-charts'
    });
        

    isNotRegistered('obrien-performance-numbers') && (binding.modules['obrien-performance-numbers'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-performance-numbers' */
            'partner/modules/obrien-performance-numbers/obrien-performance-numbers.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-performance-numbers',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-performance-numbers'
    });
        

    isNotRegistered('obrien-product-header') && (binding.modules['obrien-product-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-product-header' */
            'partner/modules/obrien-product-header/obrien-product-header.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-product-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-product-header'
    });
        

    isNotRegistered('obrien-product-registration-form') && (binding.modules['obrien-product-registration-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-product-registration-form' */
            'partner/modules/obrien-product-registration-form/obrien-product-registration-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-product-registration-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-product-registration-form'
    });
        

    isNotRegistered('obrien-product-slider') && (binding.modules['obrien-product-slider'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-product-slider' */
            'partner/modules/obrien-product-slider/obrien-product-slider.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-product-slider',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-product-slider'
    });
        

    isNotRegistered('obrien-product-video') && (binding.modules['obrien-product-video'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-product-video' */
            'partner/modules/obrien-product-video/obrien-product-video.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-product-video',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-product-video'
    });
        

    isNotRegistered('obrien-promo-banner') && (binding.modules['obrien-promo-banner'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-promo-banner' */
            'partner/modules/obrien-promo-banner/obrien-promo-banner.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-promo-banner',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-promo-banner'
    });
        

    isNotRegistered('obrien-prop65') && (binding.modules['obrien-prop65'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-prop65' */
            'partner/modules/obrien-prop65/obrien-prop65.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-prop65',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-prop65'
    });
        

    isNotRegistered('obrien-retailers') && (binding.modules['obrien-retailers'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-retailers' */
            'partner/modules/obrien-retailers/obrien-retailers.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-retailers',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-retailers'
    });
        

    isNotRegistered('obrien-return-form') && (binding.modules['obrien-return-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-return-form' */
            'partner/modules/obrien-return-form/obrien-return-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-return-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-return-form'
    });
        

    isNotRegistered('obrien-search-result-container') && (binding.modules['obrien-search-result-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-search-result-container' */
            'partner/modules/obrien-search-result-container/obrien-search-result-container.tsx'),
        $type: 'containerModule',
        da: [{name:'category',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category', runOn: 0},{name:'categoryHierarchy',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy', runOn: 0},{name:'featureProduct',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'listPageState',  path:'modules/obrien-search-result-container/list-page-state', runOn: 0},{name:'products',  path:'modules/obrien-search-result-container/actions/get-full-products-by-collection', runOn: 0},{name:'refiners',  path:'modules/obrien-search-result-container/actions/get-refiners-for-collection', runOn: 0},{name:'searchConfiguration',  path:'modules/obrien-search-result-container/actions/get-mapped-search-configuration', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-search-result-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-search-result-container'
    });
        

    isNotRegistered('obrien-simple-div') && (binding.modules['obrien-simple-div'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-simple-div' */
            'partner/modules/obrien-simple-div/obrien-simple-div.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-simple-div',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-simple-div'
    });
        

    isNotRegistered('obrien-slide-container') && (binding.modules['obrien-slide-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-slide-container' */
            'partner/modules/obrien-slide-container/obrien-slide-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-slide-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-slide-container'
    });
        

    isNotRegistered('obrien-slide-container23') && (binding.modules['obrien-slide-container23'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-slide-container23' */
            'partner/modules/obrien-slide-container23/obrien-slide-container23.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-slide-container23',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-slide-container23'
    });
        

    isNotRegistered('obrien-slide-parallax') && (binding.modules['obrien-slide-parallax'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-slide-parallax' */
            'partner/modules/obrien-slide-parallax/obrien-slide-parallax.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-slide-parallax',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-slide-parallax'
    });
        

    isNotRegistered('obrien-tabbed-container') && (binding.modules['obrien-tabbed-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-tabbed-container' */
            'partner/modules/obrien-tabbed-container/obrien-tabbed-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-tabbed-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-tabbed-container'
    });
        

    isNotRegistered('obrien-team-container') && (binding.modules['obrien-team-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-team-container' */
            'partner/modules/obrien-team-container/obrien-team-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-team-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-team-container'
    });
        

    isNotRegistered('obrien-triple-slider') && (binding.modules['obrien-triple-slider'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-triple-slider' */
            'partner/modules/obrien-triple-slider/obrien-triple-slider.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-triple-slider',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-triple-slider'
    });
        

    isNotRegistered('obrien-upc') && (binding.modules['obrien-upc'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-upc' */
            'partner/modules/obrien-upc/obrien-upc.tsx'),
        $type: 'contentModule',
        da: [{name:'product',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant', runOn: 0},{name:'productSpecificationData',  path:'@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-upc',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-upc'
    });
        

    isNotRegistered('obrien-vimeo') && (binding.modules['obrien-vimeo'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-vimeo' */
            'partner/modules/obrien-vimeo/obrien-vimeo.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-vimeo',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-vimeo'
    });
        

    isNotRegistered('obrien-warranty-form') && (binding.modules['obrien-warranty-form'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-warranty-form' */
            'partner/modules/obrien-warranty-form/obrien-warranty-form.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-warranty-form',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-warranty-form'
    });
        

    isNotRegistered('obrien-youtube') && (binding.modules['obrien-youtube'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-youtube' */
            'partner/modules/obrien-youtube/obrien-youtube.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-youtube',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-youtube'
    });
        

    isNotRegistered('obrien-zendesk') && (binding.modules['obrien-zendesk'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien-zendesk' */
            'partner/modules/obrien-zendesk/obrien-zendesk.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrien-zendesk',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrien-zendesk'
    });
        

    isNotRegistered('obrien23') && (binding.modules['obrien23'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrien23' */
            'partner/themes/obrien23/obrien23.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['checkout-section-container','checkout','search-result-container'],
        iNM: false,
        ns: '__local__',
        n: 'obrien23',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'obrien23.theme.settings.json',
        md: 'src/themes/obrien23'
    });
        

    isNotRegistered('obrienb2b') && (binding.modules['obrienb2b'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrienb2b' */
            'partner/themes/obrienb2b/obrienb2b.tsx'),
        $type: 'themeModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'obrienb2b',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'obrienb2b.theme.settings.json',
        md: 'src/themes/obrienb2b'
    });
        

    isNotRegistered('obrienb2b-header') && (binding.modules['obrienb2b-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrienb2b-header' */
            'partner/modules/obrienb2b-header/obrienb2b-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'obrienb2b-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrienb2b-header'
    });
        

    isNotRegistered('obrienb2b-navigation-menu') && (binding.modules['obrienb2b-navigation-menu'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrienb2b-navigation-menu' */
            'partner/modules/obrienb2b-navigation-menu/obrienb2b-navigation-menu.tsx'),
        $type: 'contentModule',
        da: [{name:'categories',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'obrienb2b-navigation-menu',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrienb2b-navigation-menu'
    });
        

    isNotRegistered('obriendata-order-confirmation') && (binding.modules['obriendata-order-confirmation'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obriendata-order-confirmation' */
            'partner/modules/obriendata-order-confirmation/obriendata-order-confirmation.tsx'),
        $type: 'contentModule',
        da: [{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'loyaltyCard',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card', runOn: 1},{name:'orderHydration',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-confirmation-with-hydrations', runOn: 0},{name:'tenderTypes',  path:'@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'obriendata-order-confirmation',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obriendata-order-confirmation'
    });
        

    isNotRegistered('obrienliquid-checkout-payment-instrument') && (binding.modules['obrienliquid-checkout-payment-instrument'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-obrienliquid-checkout-payment-instrument' */
            'partner/modules/obrienliquid-checkout-payment-instrument/obrienliquid-checkout-payment-instrument.tsx'),
        $type: 'contentModule',
        da: [{name:'cardPaymentAcceptPoint',  path:'modules/obrienliquid-checkout-payment-instrument/actions/get-card-payment-accept-point', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'obrienliquid-checkout-payment-instrument',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/obrienliquid-checkout-payment-instrument'
    });
        

    isNotRegistered('recaptcha-checkout') && (binding.modules['recaptcha-checkout'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-recaptcha-checkout' */
            'partner/modules/recaptcha-checkout/recaptcha-checkout.tsx'),
        $type: 'containerModule',
        da: [{name:'catalogs',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs', runOn: 0},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'customerInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'deliveryOptions',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0},{name:'orgUnitLocations',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations', runOn: 1},{name:'products',  path:'modules/recaptcha-checkout/actions/get-products-in-active-recaptcha-checkout-cart', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'recaptcha-checkout',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/recaptcha-checkout'
    });
        

    isNotRegistered('recaptcha-payment-instrument') && (binding.modules['recaptcha-payment-instrument'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-recaptcha-payment-instrument' */
            'partner/modules/recaptcha-payment-instrument/recaptcha-payment-instrument.tsx'),
        $type: 'contentModule',
        da: [{name:'cardPaymentAcceptPoint',  path:'modules/recaptcha-payment-instrument/actions/get-card-payment-accept-point', runOn: 1},{name:'channelDeliveryOptionConfig',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration', runOn: 0},{name:'checkout',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action', runOn: 1},{name:'featureState',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state', runOn: 0}],
        
        iNM: false,
        ns: '__local__',
        n: 'recaptcha-payment-instrument',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/recaptcha-payment-instrument'
    });
        

    isNotRegistered('watersportdiscounts') && (binding.modules['watersportdiscounts'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-watersportdiscounts' */
            'partner/themes/watersportdiscounts/watersportdiscounts.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['buybox'],
        iNM: false,
        ns: '__local__',
        n: 'watersportdiscounts',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'watersportdiscounts.theme.settings.json',
        md: 'src/themes/watersportdiscounts'
    });
        

    isNotRegistered('watersportdiscounts-contact') && (binding.modules['watersportdiscounts-contact'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-watersportdiscounts-contact' */
            'partner/modules/watersportdiscounts-contact/watersportdiscounts-contact.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'watersportdiscounts-contact',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/watersportdiscounts-contact'
    });
        

    isNotRegistered('watersportdiscounts-header') && (binding.modules['watersportdiscounts-header'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-watersportdiscounts-header' */
            'partner/modules/watersportdiscounts-header/watersportdiscounts-header.tsx'),
        $type: 'containerModule',
        da: [{name:'accountInformation',  path:'@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer', runOn: 0},{name:'cart',  path:'@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action', runOn: 0},{name:'storeSelectorStateManager',  path:'@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action', runOn: 1}],
        
        iNM: false,
        ns: '__local__',
        n: 'watersportdiscounts-header',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/watersportdiscounts-header'
    });
        

    isNotRegistered('watersportdiscounts-slide') && (binding.modules['watersportdiscounts-slide'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-watersportdiscounts-slide' */
            'partner/modules/watersportdiscounts-slide/watersportdiscounts-slide.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'watersportdiscounts-slide',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/watersportdiscounts-slide'
    });
        

    isNotRegistered('watersportdiscounts-slide-container') && (binding.modules['watersportdiscounts-slide-container'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-watersportdiscounts-slide-container' */
            'partner/modules/watersportdiscounts-slide-container/watersportdiscounts-slide-container.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'watersportdiscounts-slide-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/watersportdiscounts-slide-container'
    });
        

    isNotRegistered('watersportdiscounts-warranty') && (binding.modules['watersportdiscounts-warranty'] = {
        c: async () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
                
                /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
                /* webpackChunkName: '__local__-__local__-watersportdiscounts-warranty' */
            'partner/modules/watersportdiscounts-warranty/watersportdiscounts-warranty.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'watersportdiscounts-warranty',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/watersportdiscounts-warranty'
    });
        

        {   
            const actionPath = 'actions/el-get-sales-order-action.action';
            binding.dataActions[actionPath] = require('partner/actions/el-get-sales-order-action.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-collection.action';
            binding.dataActions[actionPath] = require('partner/actions/get-collection.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-refiners-for-collection.action';
            binding.dataActions[actionPath] = require('partner/actions/get-refiners-for-collection.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/video-list.action';
            binding.dataActions[actionPath] = require('partner/actions/video-list.action');
            registerActionId(actionPath);
        }

        if (isNotRegistered('absolute-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-checkout-delivery-options')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-checkout-recaptcha')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-checkout-recaptcha')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-checkout-recaptcha')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-checkout-recaptcha')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-checkout-recaptcha')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-checkout-recaptcha')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-checkout-recaptcha')){
            const sanitizedActionPath = 'modules/absolute-checkout-recaptcha/actions/get-products-in-active-absolute-checkout-recaptcha-cart';
            let dataAction = require('partner/modules/absolute-checkout-recaptcha/actions/get-products-in-active-absolute-checkout-recaptcha-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-datalayer-begincheckout')){
            const sanitizedActionPath = 'modules/absolute-datalayer-begincheckout/actions/get-products-in-active-absolute-layer-checkout-cart';
            let dataAction = require('partner/modules/absolute-datalayer-begincheckout/actions/get-products-in-active-absolute-layer-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-full-charts')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-full-charts')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-layer-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-layer-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-layer-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-layer-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-layer-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-layer-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-layer-checkout')){
            const sanitizedActionPath = 'modules/absolute-layer-checkout/actions/get-products-in-active-absolute-layer-checkout-cart';
            let dataAction = require('partner/modules/absolute-layer-checkout/actions/get-products-in-active-absolute-layer-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-prop65')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-prop65')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-salesdata')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-confirmation-with-hydrations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-confirmation-with-hydrations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-salesdata')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-salesdata')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-salesdata')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-salesdata')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-search-result-container')){
            const sanitizedActionPath = 'modules/absolute-search-result-container/actions/get-full-products-by-collection';
            let dataAction = require('partner/modules/absolute-search-result-container/actions/get-full-products-by-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-search-result-container')){
            const sanitizedActionPath = 'modules/absolute-search-result-container/actions/get-mapped-search-configuration';
            let dataAction = require('partner/modules/absolute-search-result-container/actions/get-mapped-search-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-search-result-container')){
            const sanitizedActionPath = 'modules/absolute-search-result-container/actions/get-refiners-for-collection';
            let dataAction = require('partner/modules/absolute-search-result-container/actions/get-refiners-for-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-search-result-container')){
            const sanitizedActionPath = 'modules/absolute-search-result-container/list-page-state';
            let dataAction = require('partner/modules/absolute-search-result-container/list-page-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('absolute-terms-conditions')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('aquaglide-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('aquaglide-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('aquaglide-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('aquaglide-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-availabilities-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-items-in-wishlist');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-products-in-active-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/order-templates/get-order-templates-preview');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-cart')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('arborb2b-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('base-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('base-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('base-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('base-header-2023')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('base-header-2023')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('base-header-2023')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('base-header-2023')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('base-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connelly-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-business-partner-user');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connelly-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connelly-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer-balance');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connelly-invoices-list')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/invoices/get-invoices');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connellyb2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connellyb2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connellyb2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connellyb2b-header-2023')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connellyb2b-header-2023')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connellyb2b-header-2023')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-wishlist-by-customer-id');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connellyb2b-header-2023')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/get-cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('connellyb2b-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('el-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('el-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('el-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('el-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('el-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('freedom-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('freedom-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('freedom-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('freedom-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('hosports-b2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('hosports-b2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('hosports-b2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('hosports-b2b-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('kent-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('kent-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('kent-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid-header-2021')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid-header-2021')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid-header-2021')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid-navigation-menu-2022')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid-upc')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid-upc')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid23-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid23-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid23-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid23-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid23-search-result-container')){
            const sanitizedActionPath = 'modules/liquid23-search-result-container/actions/get-full-products-by-collection';
            let dataAction = require('partner/modules/liquid23-search-result-container/actions/get-full-products-by-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid23-search-result-container')){
            const sanitizedActionPath = 'modules/liquid23-search-result-container/actions/get-mapped-search-configuration';
            let dataAction = require('partner/modules/liquid23-search-result-container/actions/get-mapped-search-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid23-search-result-container')){
            const sanitizedActionPath = 'modules/liquid23-search-result-container/actions/get-refiners-for-collection';
            let dataAction = require('partner/modules/liquid23-search-result-container/actions/get-refiners-for-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('liquid23-search-result-container')){
            const sanitizedActionPath = 'modules/liquid23-search-result-container/list-page-state';
            let dataAction = require('partner/modules/liquid23-search-result-container/list-page-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-checkout')){
            const sanitizedActionPath = 'modules/lli-checkout/actions/get-products-in-active-lli-checkout-cart';
            let dataAction = require('partner/modules/lli-checkout/actions/get-products-in-active-lli-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-checkout-additional-info')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-checkout-additional-info')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-channels');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('lli-order-history')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-checkout')){
            const sanitizedActionPath = 'modules/obrien-checkout/actions/get-products-in-active-obrien-checkout-cart';
            let dataAction = require('partner/modules/obrien-checkout/actions/get-products-in-active-obrien-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-checkout-payment-instrument')){
            const sanitizedActionPath = 'modules/obrien-checkout-payment-instrument/actions/get-card-payment-accept-point';
            let dataAction = require('partner/modules/obrien-checkout-payment-instrument/actions/get-card-payment-accept-point');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-header-2021')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-header-2021')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-header-2021')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-header-2023')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-header-2023')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-header-2023')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-prop65')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-prop65')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-current-category-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-search-result-container')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-search-result-container')){
            const sanitizedActionPath = 'modules/obrien-search-result-container/actions/get-full-products-by-collection';
            let dataAction = require('partner/modules/obrien-search-result-container/actions/get-full-products-by-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-search-result-container')){
            const sanitizedActionPath = 'modules/obrien-search-result-container/actions/get-mapped-search-configuration';
            let dataAction = require('partner/modules/obrien-search-result-container/actions/get-mapped-search-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-search-result-container')){
            const sanitizedActionPath = 'modules/obrien-search-result-container/actions/get-refiners-for-collection';
            let dataAction = require('partner/modules/obrien-search-result-container/actions/get-refiners-for-collection');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-search-result-container')){
            const sanitizedActionPath = 'modules/obrien-search-result-container/list-page-state';
            let dataAction = require('partner/modules/obrien-search-result-container/list-page-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-upc')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/product-specification/dist/lib/dataActions/get-attributes-for-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrien-upc')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-selected-variant');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrienb2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrienb2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrienb2b-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrienb2b-navigation-menu')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-categories-hierarchy');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obriendata-order-confirmation')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-confirmation-with-hydrations';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-sales-order-confirmation-with-hydrations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obriendata-order-confirmation')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types';
            let dataAction = require('@msdyn365-commerce-modules/order-management/dist/lib/actions/get-tender-types');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obriendata-order-confirmation')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obriendata-order-confirmation')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obriendata-order-confirmation')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-loyalty-card');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrienliquid-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrienliquid-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrienliquid-checkout-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('obrienliquid-checkout-payment-instrument')){
            const sanitizedActionPath = 'modules/obrienliquid-checkout-payment-instrument/actions/get-card-payment-accept-point';
            let dataAction = require('partner/modules/obrienliquid-checkout-payment-instrument/actions/get-card-payment-accept-point');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-catalogs');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-delivery-options-for-cartlines');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/search-org-unit-locations');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-checkout')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-checkout')){
            const sanitizedActionPath = 'modules/recaptcha-checkout/actions/get-products-in-active-recaptcha-checkout-cart';
            let dataAction = require('partner/modules/recaptcha-checkout/actions/get-products-in-active-recaptcha-checkout-cart');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-channel-delivery-option-configuration');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-feature-state');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-payment-instrument')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/checkout-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('recaptcha-payment-instrument')){
            const sanitizedActionPath = 'modules/recaptcha-payment-instrument/actions/get-card-payment-accept-point';
            let dataAction = require('partner/modules/recaptcha-payment-instrument/actions/get-card-payment-accept-point');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('watersportdiscounts-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action';
            let dataAction = require('@msdyn365-commerce-modules/bopis-utilities/dist/lib/store-selector-state-manager/store-selector-state-manager-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('watersportdiscounts-header')){
            const sanitizedActionPath = '@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer';
            let dataAction = require('@msdyn365-commerce-modules/retail-actions/dist/lib/get-customer');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

        if (isNotRegistered('watersportdiscounts-header')){
            const sanitizedActionPath = '@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action';
            let dataAction = require('@msdyn365-commerce/global-state/dist/lib/data-actions/cart-state-data-action');
            registerSanitizedActionPath(sanitizedActionPath, dataAction);
        }
            

    
    } catch (e) {
        handleError('-', e);
    }
    
    return binding;
};